const transformDirection = () => {
  // Get the lang attribute of the HTML root element
  const htmlDirection = document.documentElement.dir;

  // Check if the dir attribute is set to "rtl"
  if (htmlDirection === 'rtl') {
    return -1;
  } else {
    return 1;
  }
}

export { transformDirection };